import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

import enMessages from '../../../l18n/locales/en.json';
import fiMessages from '../../../l18n/locales/fi.json';
import svMessages from '../../../l18n/locales/sv.json';

import browserLanguage from 'lib/browserLanguage';

const getMessages = lang => (lang === 'fi' ? fiMessages : lang === 'sv' ? svMessages : enMessages);

function mapStateToProps(state) {
  let lang = browserLanguage;
  if (state.session && state.session.lang) lang = state.session.lang;
  const messages = getMessages(lang);

  return { locale: lang, key: lang, messages: messages };
}

export default connect(mapStateToProps)(IntlProvider);
